export class UBSPatientStruct {
    public idPatient: number | null = null;
    public idHealthUnit: number | null = null;
    public idGender: number | null = null;
    public idEthnicity: number | null = null;
    public imc: number | null = null;
    public systolicPressure: number | null = null;
    public diastolicPressure: number | null = null;
    public optin: boolean = false;
    public patientCpf: string = '';
    public cns: string = '';
    public name: string = '';
    public socialName: string = '';
    public motherName: string = '';
    public fatherName: string = '';
    public patientBirthDate: Date | null = null;
    public height: number | null = null;
    public weight: number | null = null;
    public hasDiabetes: boolean = false;
    public hasHighCholesterol: boolean = false;
    public hasHypertension: boolean = false;
    public haveOverweightObesity: boolean = false;
    public householdIncome: string = '';
    public tookHypertensionMedication: boolean = false;
    public treatedDiabetes: boolean = false;
    public trackWeighWithProfessional: boolean = false;
    public takeMedicineCholesterol: boolean = false;
    public paCathegory: number | null = null;
    public token: string = '';
    public listIdHealthUnitInGroup: number[] = [];
}